import React, { ReactNode, useEffect, useState } from 'react';
import Select from '../../components/Select';
import { OrderByOption } from '../../pages/trafficlightreport/types';

interface ReportToolBarProps {
  orderByOptions: OrderByOption<any>[];
  setOrderBy: (value: { property: string; desc: boolean }) => void;
  children?: ReactNode;
  storageKey?: string;
}

const ReportToolBar: React.FC<ReportToolBarProps> = ({
  orderByOptions,
  setOrderBy,
  children,
  storageKey = 'defaultOrderBy', // Default key if none provided
}) => {
  const [initialKey] = useState<string | undefined>(() => {
    const savedOrderBy = localStorage.getItem(storageKey);
    if (savedOrderBy) {
      try {
        const parsedOrderBy = JSON.parse(savedOrderBy);
        return parsedOrderBy.property;
      } catch (error) {
        console.error('Error parsing saved order by:', error);
      }
    }
    return orderByOptions[0]?.key;
  });

  useEffect(() => {
    // Read from local storage on mount
    const savedOrderBy = localStorage.getItem(storageKey);
    if (savedOrderBy) {
      try {
        const parsedOrderBy = JSON.parse(savedOrderBy);
        setOrderBy(parsedOrderBy);
      } catch (error) {
        console.error('Error parsing saved order by:', error);
      }
    } else {
      // Default to created date
      setOrderBy({ property: 'createddate', desc: true });
    }
  }, [storageKey, setOrderBy]);

  return (
    <div className={'d-flex gap-2 flex-wrap'}>
      <div style={{ marginRight: 'auto' }} className="selectWrapper">
          <Select
            initialSelectedKey={initialKey}
            placeholder={`Order By: ${orderByOptions[0]?.text || ''}`}
            options={orderByOptions.map(option => ({
              key: option.key as string,
              text: `Order By: ${option.text}`,
              order: option.order,
            }))}
            onChange={(event, item) => {
              const orderOption = item as unknown as OrderByOption;
              const newOrderBy = {
                property: orderOption.key as string,
                desc: orderOption.order === 'desc',
              };
              setOrderBy(newOrderBy);
              // Save to local storage
              localStorage.setItem(storageKey, JSON.stringify(newOrderBy));
            }}
          label={undefined as any}
        />
      </div>

      <>{children}</>
    </div>
  );
};

export default ReportToolBar;
